import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import Image from "src/Components/Common/Image";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_DOW_DEMO_DNA1_6 = {
  title:
    "Meet Tony, an operations manager who \nutilizes the cost management tool to \nmonitor the business costs associated \nwith the Telco's platform.",
  subtitle: "Data Operations Workbench demo",
  label: [{ iconPath: "start.png", text: "Cost Management" }],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(111),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "607px",
            zIndex: 1,
          }}
          imagePath="DNA1/DNA1_demo_2_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-79px",
          }}
          imagePath="characters/character_dna1_2.gif"
        />
      </div>
    </div>
  ),
};
